import React, { useEffect, useState } from 'react';

import { NextDropDateSeparator } from './next-drop-date-separator';
import { NextDropDateDigit } from './next-drop-date-digit';
import { T } from '../../../../../../constants';

interface NextDropDateProps {
  date: Date;
}

// under a second, so a slightly late tick doesn't skip a digit
const TIMER_INTERVAL = 900;

const getRemainingSeconds = (date: Date): number => {
  return Math.max(Math.floor((date.getTime() - Date.now()) / 1000), 0);
};

export const NextDropDate: React.FC<NextDropDateProps> = ({ date }) => {

  const [remainingSeconds, setRemainingSeconds] = useState(() => getRemainingSeconds(date));

  // restarts for every date: a popup left open past a drop stays at 0 until the drop scene ends,
  // then it gets the following drop's date
  useEffect(() => {
    const updateTimer = () => setRemainingSeconds(getRemainingSeconds(date));
    updateTimer();
    const interval = setInterval(updateTimer, TIMER_INTERVAL);
    return () => clearInterval(interval);
  }, [date]);

  const days = Math.floor(remainingSeconds / 86400);
  const hours = Math.floor((remainingSeconds % 86400) / 3600);
  const minutes = Math.floor((remainingSeconds % 3600) / 60);
  const seconds = remainingSeconds % 60;

  return (
    <div className="free-drop-live-data">
      <NextDropDateDigit
        name={T.DAYS_TOURNAMENT}
        digit={days}
      />
      <NextDropDateSeparator />
      <NextDropDateDigit
        name={T.HRS_TOURNAMENT}
        digit={hours}
      />
      <NextDropDateSeparator />
      <NextDropDateDigit
        name={T.MINS_TOURNAMENT}
        digit={minutes}
      />
      <NextDropDateSeparator />
      <NextDropDateDigit
        name={T.SECS_TOURNAMENT}
        digit={seconds}
      />
    </div>
  );
};
